<template>
    <main id="LmPeopleSearcher">
      <LmComponentLoading v-if="isLoading" fixed />

      <!-- Primer paso (selecciono tipo de persona/iniciador) -->
      <b-modal
        id="starter-seleccion-modal"
        :title="peopleModalTitle"
        hide-footer
        centered
        size="xl"
      >
        <b-row v-if="starterTypes.length" cols="1" cols-md="4" cols-xl="8">
          <!-- Debo seleccionar un tipo de persona o tipo de iniciador -->
          <b-col v-for="starter in starterTypes" :key="starter._id">
            <b-card
              border-variant="primary"
              :header="starter.typeName"
              header-bg-variant="primary"
              header-text-variant="white"
              class="border clickable"
              align="center"
              @click="starterSelect(starter)"
            >
              <b-card-text>{{ starter.typeDescription }}</b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-modal>

      <!-- Segundo paso (busco la persona o iniciador. O lo creo) -->
      <b-modal
        id="starter-searcher-modal"
        :title="`Buscar`"
        hide-footer
        centered
        size="xl"
      >
        <div v-if="starterTypeSelected">
          <div v-if="starterTypeSelected.starterType === 'people'">
            <h3 class="mb-0">Persona: {{ starterTypeSelected.typeName }}</h3>

            <!-- Buscador de personas -->
            <form @submit.prevent="onSearchPerson">
              <b-row class="align-items-end">
                <b-col>
                  <LmTreeSelect
                    label="Tipo de identificador"
                    :options="starterTypeSelected.idType"
                    v-model="searchPersonData.personIdType"
                  />
                </b-col>
                <b-col>
                  <LmTextInput
                    label="Identificador"
                    v-model="searchPersonData.personId"
                  />
                </b-col>
                <b-col>
                  <LmButton
                    :disabled="!searchPersonData.personIdType"
                    type="submit"
                    value="Consultar"
                    buttonClass="btn-primary"
                  />
                </b-col>
              </b-row>
            </form>

            <b-row v-if="personFound">
              <!-- Persona encontrada -->
              <b-col cols="12" class="col-lg-12">
                <h4>Persona encontrada:</h4>
              </b-col>
              <b-col cols="12" md="6">
                <LmTextInput
                  disabled
                  v-model="personFound.personName"
                  label="Nombre"
                />
              </b-col>
              <b-col cols="12" md="6">
                <LmTextInput
                  disabled
                  v-model="personFound.personEmail"
                  label="Email"
                />
              </b-col>
              <b-col cols="12" md="6">
                <LmTextInput
                  disabled
                  label="Tipo de identificador"
                  v-model="personFound.personIdType.name"
                />
              </b-col>
              <b-col cols="12" md="6">
                <LmTextInput
                  disabled
                  v-model="personFound.personId"
                  label="Identificador"
                />
              </b-col>
              <!-- Formbuilder Server Components -->
              <b-col cols="12" v-if="personFound" class="col-md-12">
                <LmFormBuilder
                  isDisabled
                  disablePageTitleData
                  disablePortal
                  class="px-0 mt-3"
                  v-if="starterTypeSelected.peopleFieldsFormbuilderId"
                  ref="lmFormbuilder-people"
                  :formValues="personFound"
                  :endpointUriwhereGetComponents="formbuilderPathPeople"
                  @formObjectToSendToServerChange="peopleForm = $event"
                />
              </b-col>
            </b-row>
          </div>
          <div v-if="starterTypeSelected.starterType === 'initiator'">
            <h3 class="mb-0">Iniciador: {{ starterTypeSelected.typeName }}</h3>
            <!-- Formbuilder Server Components -->
            <LmFormBuilder
              class="px-0 mt-3"
              v-if="starterTypeSelected.formbuilderId"
              ref="lmFormbuilder-initiator"
              :endpointUriwhereGetComponents="formbuilderPathInitiator"
              :formValues="initiatorForm"
              @formObjectToSendToServerChange="initiatorForm = $event"
            />
          </div>
          <div class="d-flex" style="gap: 1rem">
            <LmButton
              @click="onCancelSecondStep"
              value="Cancelar"
              buttonClass="btn-secondary"
            />
            <LmButton
              :disabled="disableConfirmButton"
              value="Confirmar"
              @click="onConfirmStarter"
              buttonClass="btn-primary"
            />
          </div>
        </div>
      </b-modal>

      <!-- Tercer paso (propongo crear una persona) -->
      <b-modal
        id="person-new-or-edit-modal"
        title="Nueva Persona"
        hide-footer
        centered
        size="xl"
      >
        <LmPeopleNewOrEdit
          v-if="starterTypeSelected"
          :peopleTypeId="starterTypeSelected._id"
          :personData="personFound || searchPersonData"
          :isOnModalEditMode="peopleComponentOnEditMode"
          @onNewPerson="onNewPerson"
          @onUpdatePerson="onUpdatePerson"
          @cancel="onPeopleNewOrEditCancel"
        />
      </b-modal>

      <LmConfirmationModal ref="lmConfirmationModal" title="Aviso" message="No se encontró ninguna persona. Desea crearla?" @ok="$bvModal.show('modal-new-people')" />
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmForm from '@/components/form/LmForm'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmPeopleNewOrEdit from '@/views/LmPeopleNewOrEdit'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal.vue'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmTreeSelect,
    LmFormBuilder,
    LmPeopleNewOrEdit,
    LmConfirmationModal
  },
  data () {
    return {
      starterTypeSelected: null,
      starterTypes: [],
      deleted: false,
      searchPersonData: {
        personIdType: null,
        personId: null
      },
      initiatorForm: {},
      peopleForm: {},
      personFound: null,
      isLoading: false,
      mode: null,
      peopleComponentOnEditMode: false
    }
  },
  computed: {
    formbuilderPathInitiator () {
      return `/formbuilder/${this.starterTypeSelected.formbuilderId}`
    },
    formbuilderPathPeople () {
      return `/formbuilder/${this.starterTypeSelected.peopleFieldsFormbuilderId}`
    },
    dataPathOnEditMode () {
      return `/people/${this.personFound._id}`
    },
    peopleModalTitle () {
      if (this.starterTypes.length) {
        return 'Seleccione el tipo de persona o iniciador que comenzará el trámite'
      } else {
        return 'Debe crear y publicar un tipo de persona o iniciador para comenzar el trámite'
      }
    },
    disableConfirmButton () {
      if (!this.personFound && this.starterTypeSelected.starterType !== 'initiator') {
        return true
      }
      return false
    }
  },
  methods: {
    onCancelSecondStep () {
      this.$bvModal.hide('starter-searcher-modal')
      if (this.mode === null) {
        this.starterTypeSelected = null
        this.personFound = null
        this.$bvModal.show('starter-seleccion-modal')
      }
      this.mode = null
    },
    starterSelect (selection) {
      this.starterTypeSelected = selection
      this.$bvModal.hide('starter-seleccion-modal')
      this.personFound = null
      this.searchPersonData = {}
      this.initiatorForm = {}
      this.$bvModal.show('starter-searcher-modal')
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        // this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        return false
      } else {
        if (validation.$pending || validation.$error) {
          return false
        }
      }
      return true
    },
    async onSearchPerson () {
      try {
        this.isLoading = true
        if (this.starterTypeSelected.starterType === 'people' && this.searchPersonData?.personId) {
          const person = await commonsApi.axiosGetWrapper(`/people/search/${this.searchPersonData.personIdType.id}/${this.searchPersonData.personId}`)

          // Si no encuentro la persona, propongo crearla
          if (person.data.length) {
            this.personFound = person.data[0]
            this.peopleComponentOnEditMode = true
          } else {
            this.$bvModal.hide('starter-searcher-modal')
            await this.$refs.lmConfirmationModal.lmShow()
            this.personFound = null
            this.peopleComponentOnEditMode = false
            this.$bvModal.show('person-new-or-edit-modal')
          }
        }
      } catch (error) {
        console.log(error)
        if (error === 'cancel') {
          this.$bvModal.show('starter-searcher-modal')
          this.peopleComponentOnEditMode = false
        }
      } finally {
        this.isLoading = false
      }
    },
    onNewPerson (event) {
      this.personFound = event
      this.$bvModal.hide('person-new-or-edit-modal')
      this.$bvModal.show('starter-searcher-modal')
    },
    onUpdatePerson (event) {
      this.personFound = event
      this.emitSelection()
      this.$bvModal.hide('person-new-or-edit-modal')
    },
    start () {
      this.$bvModal.show('starter-seleccion-modal')
    },
    personDetails () {
      this.mode = 'details'
      this.$bvModal.show('person-new-or-edit-modal')
    },
    initiatorDetails () {
      this.mode = 'details'
      this.$bvModal.show('starter-searcher-modal')
    },
    emitSelection () {
      let objToEmit = {}
      if (this.starterTypeSelected.starterType === 'people') {
        objToEmit = {
          [this.starterTypeSelected.starterType]: {
            ...this.personFound,
            name: this.personFound.personName,
            starterTypeId: this.starterTypeSelected._id
          }
        }
        this.$emit('onSearcherPersonData', this.searchPersonData)
      }
      if (this.starterTypeSelected.starterType === 'initiator') {
        objToEmit = {
          [this.starterTypeSelected.starterType]: {
            ...this.initiatorForm[this.starterTypeSelected.initiatorIdField.id],
            starterTypeId: this.starterTypeSelected._id,
            fields: this.initiatorForm
          }
        }
        this.$emit('onSearcherPersonData', null)
      }
      this.$emit('onSelect', objToEmit)
    },
    async onConfirmStarter () {
      try {
        const valid = await this.validateForm(this.$refs[`lmFormbuilder-${this.starterTypeSelected.starterType}`].$v)
        if (valid) {
          this.emitSelection()
          this.$bvModal.hide('starter-searcher-modal')
        }
      } catch (error) {
        console.log(error)
      }
    },
    onPeopleNewOrEditCancel () {
      this.$bvModal.hide('person-new-or-edit-modal')
      if (this.mode === null) {
        this.$bvModal.show('starter-searcher-modal')
      }
      this.mode = null
    }
  },
  async created () {
    try {
      this.isLoading = true
      // Obtengo los tipos de iniciadores posibles
      const starters = await commonsApi.axiosGetWrapper(`/peopletypes/allstarterstypes/${this.$route.params.processTypeId}`)
      this.starterTypes = starters.data
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}

</script>

<style lang="sass">
  .change-peopletype
    color: blue
  .change-peopletype:hover
    text-decoration: underline
</style>
